import { render, staticRenderFns } from "./UiUx.vue?vue&type=template&id=94aeb7be&scoped=true&"
import script from "./UiUx.vue?vue&type=script&lang=js&"
export * from "./UiUx.vue?vue&type=script&lang=js&"
import style0 from "./UiUx.vue?vue&type=style&index=0&id=94aeb7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aeb7be",
  null
  
)

export default component.exports